var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { Breadcrumb } from './Breadcrumb';
/**
 * A Breadcrumb with custom styles to make it fit inside a `<TopToolbar>` used in most actions components
 * provided to views (List, Create, Edit and Show).
 *
 * @example
 * import * as React from "react";
 * import { TopToolbar, ShowButton } from 'react-admin';
 * import { BreadcrumbForActions } from '@react-admin/ra-navigation';
 *
 * const PostEditActions = ({ basePath, data, resource }) => (
 *     <TopToolbar>
 *         <BreadcrumbForActions />
 *         <ShowButton basePath={basePath} record={data} />
 *     </TopToolbar>
 * );
 *
 * export const PostEdit = (props) => (
 *     <Edit actions={<PostEditActions />} {...props}>
 *         ...
 *     </Edit>
 * );
 */
export var BreadcrumbForActions = function (props) {
    var classes = useStyles(props);
    var className = props.className, rest = __rest(props, ["className"]);
    return (React.createElement(Breadcrumb, __assign({ className: classnames(classes.root, className) }, rest)));
};
var useStyles = makeStyles({
    root: {
        // Same padding as the MuiButton with small text
        padding: '4px 5px',
        // Ensure the breadcrumb is at the left of the view
        marginRight: 'auto',
    },
}, {
    name: 'RaBreadcrumbForActions',
});
